import { Options } from 'vue-class-component';
import AssignRoomObjectGeneralStep from '../AssignRoomObjectGeneralStep';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import {
  DeviceDTO,
  DevicesFilterByType,
} from '@/../client-generator/generated-clients/plants';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';

@Options({
  name: 'Step3',
  components: {
    AddDeviceToLinkableObject,
  },
})
export default class Step3 extends AssignRoomObjectGeneralStep {
  devicesCommands: DeviceDTO[] = [];

  get currentDevicesCommands() {
    return this.roomObject.devices?.filter((x) => x.isCommandDevice);
  }

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      this.devicesCommands = await plantsClient.devices(
        this.plantId,
        this.roomId,
        this.roomObject.id ?? '',
        DevicesFilterByType.COMMANDS,
        this.roomObject.lightType || undefined,
        undefined,
        undefined,
        undefined
      );
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
